import deepmerge from 'deepmerge';
export var DeepMergeArrayStrategy;
(function (DeepMergeArrayStrategy) {
    DeepMergeArrayStrategy["REPLACE"] = "REPLACE";
    DeepMergeArrayStrategy["CONCAT"] = "CONCAT";
    DeepMergeArrayStrategy["COMBINE_ARRAYS"] = "COMBINE_ARRAYS";
})(DeepMergeArrayStrategy || (DeepMergeArrayStrategy = {}));
export const DEEP_MERGE_ARRAY_STRATEGIES = {
    [DeepMergeArrayStrategy.COMBINE_ARRAYS]: (target, source, options) => {
        const destination = target.slice();
        source.forEach((item, index) => {
            if (typeof destination[index] === 'undefined') {
                destination[index] = options.cloneUnlessOtherwiseSpecified(item, options);
            }
            else if (options.isMergeableObject(item)) {
                destination[index] = deepmerge(target[index], item, options);
            }
            else if (target.indexOf(item) === -1) {
                destination.push(item);
            }
        });
        return destination;
    },
    [DeepMergeArrayStrategy.REPLACE]: (_target, source, options) => {
        return source.map((item) => options.cloneUnlessOtherwiseSpecified(item, options));
    },
    [DeepMergeArrayStrategy.CONCAT]: undefined,
};
export function deepMerge(base, parts, arrayStrategy = DeepMergeArrayStrategy.REPLACE) {
    return deepmerge(base, parts, { arrayMerge: DEEP_MERGE_ARRAY_STRATEGIES[arrayStrategy] });
}
//# sourceMappingURL=deepMerge.js.map